<template>
  <v-container>
    <v-row class="text-center" >
      <v-col class="mb-4" >
        <h1 class="display-2 font-weight-bold mb-3 welcome">Welcome to NodePing</h1>
      </v-col>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">What's next?</h2>

        <v-row justify="center">
          <div v-for="(next, i) in whatsNext" :key="i" class="linkblock">
            <a :href="next.href" class="subheading mx-3" target="_blank">{{ next.text }}</a>
            <p>{{ next.description }}</p>
          </div>
        </v-row>
      </v-col>

      <v-col class="mb-5" cols="12" >
        <h2 class="headline font-weight-bold mb-3">Important Links</h2>

        <v-row justify="center">
          <div v-for="(link, i) in importantLinks" :key="i" class="linkblock">
            <a :href="link.href" class="subheading mx-3" target="_blank">{{ link.text }}</a>
            <p>{{ link.description }}</p>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    data: () => ({
        importantLinks: [
            {
                text: "Documentation",
                href: "https://nodeping.com/Documentation",
                description: ""
            },
            {
                text: "FAQ",
                href: "https://nodeping.com/FAQ",
                description: ""
            },
            {
                text: "About NodePing",
                href: "https://nodeping.com/About",
                description: ""
            },
            {
                text: "Contact Us",
                href: "https://nodeping.com/Contact",
                description: ""
            }
        ],
        whatsNext: [
            {
                text: "Set Up Contacts",
                href: "https://vuetifyjs.com/components/api-explorer",
                description:
          "Contacts are used to manage logins, access to your account, and notification contacts."
            },
            {
                text: "Set Up Checks",
                href: "https://vuetifyjs.com/layout/pre-defined",
                description:
          "Checks are the core of the monitoring service.  Each check monitors one service or site."
            },
            {
                text: "Configure Billing",
                href:
          "https://vuetifyjs.com/getting-started/frequently-asked-questions",
                description:
          "Set up your billing information.  We do not charge you until your trial is ended."
            }
        ]
    })
};
</script>

<style>
.linkblock {
  margin: 1em;
}
.welcome {
  padding-top: 2em;
  padding-bottom: 2em;
}
</style>
